export default function CoupounCardFloatH5(props: any) {
    return (
        <svg width="347" height="335" viewBox="0 0 347 335" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M57.2879 182.421L44.6094 181.991C43.7787 181.963 43.1716 182.767 43.4265 183.558L46.0126 191.587C46.2656 192.372 47.2174 192.674 47.8766 192.177L57.9689 184.579C58.873 183.899 58.4189 182.46 57.2879 182.421Z"
                fill="url(#paint0_linear_2364_35888)"
                stroke="url(#paint1_linear_2364_35888)"
                strokeWidth="0.4"
            />
            <circle
                cx="41.1702"
                cy="18.1703"
                r="3.2"
                transform="rotate(-34.3971 41.1702 18.1703)"
                fill="url(#paint2_linear_2364_35888)"
                stroke="url(#paint3_linear_2364_35888)"
                strokeWidth="0.4"
            />
            <circle
                cx="13.1702"
                cy="108.17"
                r="3.2"
                transform="rotate(-34.3971 13.1702 108.17)"
                fill="url(#paint4_linear_2364_35888)"
                stroke="url(#paint5_linear_2364_35888)"
                strokeWidth="0.4"
            />
            <path
                d="M300.931 33.0714L313.71 34.0279C314.539 34.0899 315.178 33.311 314.956 32.5102L312.676 24.3003C312.455 23.5053 311.516 23.165 310.838 23.634L300.338 30.8874C299.407 31.5306 299.802 32.9869 300.931 33.0714Z"
                fill="url(#paint6_linear_2364_35888)"
                stroke="url(#paint7_linear_2364_35888)"
                strokeWidth="0.4"
            />
            <path
                d="M337.315 124.912C337.418 124.726 337.405 124.512 337.336 124.305C337.267 124.097 337.133 123.871 336.953 123.633C336.592 123.155 336.014 122.59 335.272 121.974C333.784 120.74 331.603 119.279 329.082 117.879C326.561 116.48 324.167 115.401 322.334 114.79C321.419 114.485 320.633 114.294 320.037 114.24C319.739 114.213 319.477 114.22 319.264 114.27C319.052 114.321 318.863 114.423 318.76 114.609C318.657 114.795 318.67 115.009 318.739 115.216C318.808 115.423 318.942 115.649 319.122 115.888C319.483 116.366 320.061 116.931 320.803 117.547C322.291 118.78 324.472 120.241 326.993 121.641C329.514 123.041 331.908 124.12 333.741 124.73C334.656 125.035 335.442 125.227 336.038 125.281C336.336 125.308 336.598 125.301 336.811 125.25C337.023 125.2 337.212 125.097 337.315 124.912Z"
                fill="url(#paint8_linear_2364_35888)"
                stroke="url(#paint9_linear_2364_35888)"
                strokeWidth="0.4"
            />
            <circle
                cx="335.554"
                cy="234.554"
                r="2.62731"
                transform="rotate(3.06982 335.554 234.554)"
                fill="url(#paint10_linear_2364_35888)"
                stroke="url(#paint11_linear_2364_35888)"
                strokeWidth="0.4"
            />
            <defs>
                <linearGradient id="paint0_linear_2364_35888" x1="70.811" y1="185.075" x2="62.0036" y2="201.879" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_2364_35888" x1="64.6025" y1="180.337" x2="66.6797" y2="187.305" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint2_linear_2364_35888" x1="44.1702" y1="11.6078" x2="48.86" y2="18.3645" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint3_linear_2364_35888" x1="40.7539" y1="13.2857" x2="44.6248" y2="13.4058" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint4_linear_2364_35888" x1="16.1702" y1="101.608" x2="20.86" y2="108.364" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_2364_35888" x1="12.7539" y1="103.286" x2="16.6248" y2="103.406" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint6_linear_2364_35888" x1="287.446" y1="29.8476" x2="297.004" y2="13.2907" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint7_linear_2364_35888" x1="293.502" y1="34.8721" x2="291.697" y2="27.7713" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint8_linear_2364_35888" x1="309.072" y1="106.998" x2="315.382" y2="100.499" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint9_linear_2364_35888" x1="313.085" y1="111.768" x2="314.321" y2="109.571" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint10_linear_2364_35888" x1="337.981" y1="229.244" x2="341.775" y2="234.711" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint11_linear_2364_35888" x1="335.217" y1="230.602" x2="338.349" y2="230.699" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
